import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';

function Header() {
  const location = useLocation();
  const isSwedish = location.pathname.startsWith('/sv'); // Check if Swedish version
  const isFinnishHome = location.pathname === '/'; // Check if on Finnish home page
  const isSwedishHome = location.pathname === '/sv'; // Check if on Swedish home page

  return (
    <header className="App-header">
      <nav>
        <ul>
          {/* Show "Koti" if NOT on the Finnish home page */}
          {!isFinnishHome && !isSwedish && <li><a href="/">Koti</a></li>}
          {!isSwedishHome && isSwedish && <li><a href="/sv">Hem</a></li>}

          <li><a href={isSwedish ? "/sv/kaivuutyot" : "/kaivuutyot"}>{isSwedish ? "Grävarbeten" : "Kaivuutyöt"}</a></li>
          <li><a href={isSwedish ? "/sv/kivityot" : "/kivityot"}>{isSwedish ? "Stenarbeten" : "Kivityöt"}</a></li>
          <li><a href={isSwedish ? "/sv/rakennustyot" : "/rakennustyot"}>{isSwedish ? "Byggnadsarbeten" : "Rakennustyöt"}</a></li>
          <li><a href={isSwedish ? "/sv/sahkotyot" : "/sahkotyot"}>{isSwedish ? "Elarbeten" : "Sähkötyöt"}</a></li>
        </ul>
      </nav>

      <h1 className="App-title">Jbygg</h1>

      {/* Language switch: Show Finnish flag if on Swedish page, otherwise show Swedish flag */}
      <a href={isSwedish ? "/" : "/sv"} className="language-switch" aria-label="Switch language">
        {isSwedish ? (
          // Finnish flag 🇫🇮
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" className="flag-icon">
            <rect width="16" height="10" fill="white"/>
            <rect x="5" width="2" height="10" fill="#003580"/>
            <rect y="4" width="16" height="2" fill="#003580"/>
          </svg>
        ) : (
          // Swedish flag 🇸🇪
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" className="flag-icon">
            <rect width="16" height="10" fill="#006aa7"/>
            <rect x="5" width="2" height="10" fill="#fecc00"/>
            <rect y="4" width="16" height="2" fill="#fecc00"/>
          </svg>
        )}
      </a>
    </header>
  );
}

export default Header;
